import { Badge, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChatIcon from '@mui/icons-material/Chat';
import UserAvatar from '../UI/UserAvatar/UserAvatar';
import UserOptions from '../../Header/Settings/UserOptions';
import NotificationBell from '../UI/Notifications/NotificationBell';
import useNotifications from '../../Header/Notifications/useNotifications';

/**
 * Mobile top bar sa zvoncetom — mount-uje se samo na mobilnom
 * da se useNotifications ne duplira sa Header-om na desktopu.
 */
function MobileNotificationsBar({ onOpenMenu }) {
  const navigate = useNavigate();
  const {
    userNotifications,
    unreadNotifications,
    unreadOnly,
    handleUnreadFilterChange,
    handleReadNotification,
    handleOpenNotification,
    handleReadAllNotifications,
    refreshNotifications,
  } = useNotifications();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <button
        style={{ fontSize: '30px' }}
        className="fas fa-bars"
        onClick={onOpenMenu}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <NotificationBell
          unreadNotifications={unreadNotifications}
          userNotifications={userNotifications}
          onRead={handleReadNotification}
          onOpenDetails={handleOpenNotification}
          onReadAll={handleReadAllNotifications}
          unreadOnly={unreadOnly}
          onUnreadFilterChange={handleUnreadFilterChange}
          onOpen={refreshNotifications}
        />
        <Tooltip title="Chat">
          <IconButton
            onClick={() => navigate('/chat')}
            sx={{ ml: 1 }}
            size="large"
          >
            <Badge badgeContent={0} color="error" max={99}>
              <ChatIcon sx={{ color: '#1976d2' }} />
            </Badge>
          </IconButton>
        </Tooltip>
        <div style={{ display: 'inline-flex' }}>
          <UserAvatar
            user={localStorage.korinik}
            imageUrl="null"
            boja={localStorage.boja}
          />
          <span className="user-name">{localStorage.korisnik}</span>

          <UserOptions>
            <button className="header-options">
              <i className="fas fa-chevron-down" />
            </button>
          </UserOptions>
        </div>
      </div>
    </div>
  );
}

export default MobileNotificationsBar;
